import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import logo from "../../src/assets/images/aglogo.png";
import axios from "axios";
import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  Modal,
  Popover,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

// Utilities
import { useSelector, useDispatch } from "react-redux";
import swal from "sweetalert";
import {
  Fullscreenviewicon,
  Logominicon,
  Modalcloseicon,
} from "../assets/svgicons";
import { makeStyles } from "@material-ui/core";

// Redux Actions
import { LOGOUT } from ".././redux/actions/authActions";
import { REMOVE_PERMISSIONS } from ".././redux/actions/permissionsActions";
import { logoutSession } from "../services/auth-service";
import { errorSwal } from "../util/sweet-alert";
import appConfig from "../util/app-config";
import ChangePassword from "../pages/auth/change-password";
import { NotificationMenu } from "../components/notification/notification-menu";
import { NotificationDialog } from "../components/notification/notification-dialog";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { clearNotifications, getNotifications, unregisterFcmToken } from "../services/notification-service";

const useStyles = makeStyles({
  roundedicons: {
    boxShadow: "0px 2px 8px rgb(206 206 206 / 45%)",
    borderRadius: "50px",
    display: "inline-block",
    textAlign: "center",
    padding: "4px 10px",
    "&:hover": {
      boxShadow: "none",
    },
  },
});

const style1 = {
  position: "absolute",
  left: "50%",
  transform: "translate(-50%, 10%)",
  width: "60%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 2,
};

const Navbar = ({ handleToggle, toggleButtonRef }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { authToken, ...logindata } = useSelector((state) => state.auth);
  const [openchangepassword, setOpenChangepassword] = useState(false);
  const history = useHistory();

  const [tabledisplay, setTabledisplay] = useState(false);
  const [confirmSignOut, setconfirmSignOut] = useState(false);
  const dropdownOptionRef = useRef();
  const [signOutFromDevices, setSignOutFromDevices] = useState(false);

  const [loginList, setLoginList] = useState([]);
  const [anchorElLoginList, setAnchorElLoginList] = useState(null);

  const handleCloseLoginList = () => {
    setAnchorElLoginList(null);
  };

  const openLoginList = Boolean(anchorElLoginList);

  const handler = (e) => {
    if (!dropdownOptionRef.current.contains(e.target)) {
      setSignOutFromDevices(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  // Logout mutation with token cleanup
  const logoutMutation = useMutation({
    mutationFn: async (allDevices = false) => {
      // Unregister FCM token before logout
      try {
        await unregisterFcmToken(authToken);
      } catch (err) {
        console.error("Failed to unregister FCM token:", err);
        // Continue with logout even if this fails
      }

      return logoutSession({ logout_all_device: allDevices }, authToken);
    },
    onMutate: () => queryClient.cancelQueries({ fetching: true }),
    onSuccess: () => {
      queryClient.clear();
      dispatch({ type: REMOVE_PERMISSIONS });
      dispatch({ type: LOGOUT });

      history.push("/login");
      setTimeout(() => window.location.reload(), 1000);
    },
    onError: () => errorSwal(),
    retry: false,
  });

  // const onClickHandler = async (event) => {
  //   try {
  //     const eAppResponse = await getEAppsCredentials(token);

  //     if (eAppResponse?.error) {
  //       swal({
  //         title: "Error",
  //         text: `Credentials are not in eApplication`,
  //         icon: "error",
  //       });
  //     } else {
  //       setLoginList(eAppResponse);
  //     }

  //     //  Laravel BE - get eapp credentials
  //     if (eAppResponse?.length > 1) {
  //       setAnchorElLoginList(event.currentTarget);
  //     } else {
  //       const response = await axios.post(
  //         "https://eapps.axiumgenie.com/eApplications/auth/login",
  //         {
  //           username: eAppResponse?.[0]?.username,
  //           password: eAppResponse?.[0]?.decrypted,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         }
  //       );

  //       if (response.data != "no_access") {
  //         let params = encodeURIComponent(JSON.stringify(response.data));
  //         window.open(
  //           "https://eapps.axiumgenie.com/eApplications/index/dashboard?params=" +
  //           params,
  //           "_blank"
  //         );
  //       } else {
  //         swal({
  //           title: "Error",
  //           text: `eApps Password is Invalid`,
  //           icon: "error",
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     errorSwal();
  //   }
  // };

  const loginAsUser = async (user) => {
    try {
      const response = await axios.post(
        "https://eapps.axiumgenie.com/eApplications/auth/login",
        {
          username: user?.username,
          password: user?.decrypted,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      if (response.data !== "no_access") {
        let params = encodeURIComponent(JSON.stringify(response.data));
        window.open(
          "https://eapps.axiumgenie.com/eApplications/index/dashboard?params=" +
          params,
          "_blank",
        );
      } else {
        swal({
          title: "Error",
          text: `eApps Password is Invalid`,
          icon: "error",
        });
      }
    } catch (err) {
      errorSwal();
    }
  };

  // notification

  const { data: notificationData, isFetching: notificationLoading } = useQuery(
          "notifications",
          () => getNotifications(authToken),
          {
              refetchOnWindowFocus: false,
              staleTime: 5 * 60 * 1000,
              cacheTime: 30 * 60 * 1000, // Keep in cache for 30 min even after modal closes
          }
      );

 const markAllAsReadMutation = useMutation(() => clearNotifications(authToken), {
    onSuccess: () => {
      // Refresh the notifications query after marking as read
      queryClient.invalidateQueries(["notifications"]);
    },
  });

  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a className="navbar-brand brand-logo" href="index.html">
          <img src={logo} alt="logo" />
        </a>
        <a className="navbar-brand brand-logo-mini" href="index.html">
          <Logominicon width={30} />
        </a>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button
          className="navbar-toggler navbar-toggler align-self-center"
          type="button"
          data-toggle="minimize"
        >
          <span className="mdi mdi-menu"></span>
        </button>

        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item d-none d-lg-block full-screen-link">
            <a className="nav-link">
              <Tooltip title="Fullscreen">
                <Box className={classes.roundedicons} id="fullscreen-button">
                  <Fullscreenviewicon width={15} />
                </Box>
              </Tooltip>
            </a>
          </li>

          <NotificationMenu onModalDisplay={() => setTabledisplay(prev => !prev)} notificationData={notificationData} notificationLoading={notificationLoading} markAllAsReadMutation={markAllAsReadMutation}/>
          <NotificationDialog open={tabledisplay} onClose={() => setTabledisplay(false)} notificationData={notificationData} />

          <li className="nav-item nav-profile dropdown" ref={dropdownOptionRef}>
            <a
              className="nav-link dropdown-toggle"
              id="profileDropdown"
              href="#"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <div className="nav-profile-text">
                <p className="mb-1 text-black">{logindata.name}</p>
              </div>
              <div className="nav-profile-img">
                <Avatar
                  src={appConfig.baseURL + logindata.imgsrc}
                  alt={logindata.name}
                  sx={{ width: 27, height: 27 }}
                ></Avatar>
                <span className="availability-status online"></span>
              </div>
            </a>
            <div
              className="dropdown-menu navbar-dropdown"
              aria-labelledby="profileDropdown"
            >
              <div className="dropdown-divider"></div>
              <span
                className="dropdown-item"
                onClick={() => history.push("/panel-queries")}
              >
                Help Desk
              </span>
              <span
                className="dropdown-item"
                onClick={() => setOpenChangepassword(true)}
              >
                Change Password
              </span>

              <span
                className="dropdown-item"
                onClick={() => setconfirmSignOut(true)}
              >
                Sign Out
              </span>
            </div>
          </li>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          data-toggle="offcanvas"
          ref={toggleButtonRef}
          onClick={handleToggle}
        >
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
      <ChangePassword
        openchangepassword={openchangepassword}
        setOpenChangepassword={setOpenChangepassword}
      />

      <Popover
        open={openLoginList}
        anchorEl={anchorElLoginList}
        onClose={handleCloseLoginList}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List size="small">
          {loginList?.map((o, i) => (
            <ListItem key={i} size="small" disablePadding>
              <ListItemButton onClick={() => loginAsUser(o)} size="small">
                {o?.username}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Popover>
      <Modal
        open={confirmSignOut}
        onClose={() => setconfirmSignOut(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1} className="taskmodal">
          <Box
            className={"pointer pull-right"}
            onClick={() => setconfirmSignOut(false)}
          >
            <Modalcloseicon width={18} />
          </Box>
          <Typography sx={{ m: 2, textAlign: "center" }}>
            Are you sure you want to ?
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              className={"btn-info"}
              type="button"
              onClick={() => logoutMutation.mutate(true)}
              size="medium"
            >
              Sign Out From All Devices
            </Button>
            <Button
              variant="contained"
              className={"btn-info"}
              type="button"
              onClick={() => logoutMutation.mutate(false)}
              size="medium"
            >
              Sign Out From This Device
            </Button>
          </Stack>
        </Box>
      </Modal>
    </nav>
  );
};

export default Navbar;